import React from 'react'

const TokenContext = new React.createContext()
export default TokenContext
